'use strict';

var isObject = require('../internals/is-object');
module.exports = function (argument) {
  return isObject(argument) || argument === null;
};